module.exports = __webpack_public_path__ + "img/finland-ill-defined-causes-female.a06992ff.png";